<vp-carousel
	[config]="config"
	[contentMargin]="contentMargin()"
	[editableInStoryblok]="_editable()"
	[items]="carouselItems"
/>
